import get from 'lodash.get';

const getConstraints = (rootState) => get(rootState, 'ws.template.meta.constraints', []);

export default getConstraints;
